module.exports = __webpack_public_path__ + "images/application/i-preview-09f889a4.svg";